export default {"src":"/_next/static/media/arrow-down.aa284948.svg","height":11,"width":20,"blurWidth":0,"blurHeight":0};